// eslint-disable-next-line
import { useEffect, useState } from 'react';
import Intro from '../Components/intro.js';
import NavHeader from '../Components/navHeader.js';
import Footer from '../Components/footer.js';
import ExpandableContent from '../Components/expandableContent.js';
import ShowcaseEmbed from '../Components/EmbedShowcase.js';
import { useNotification } from '../Components/NoticeHandler.js';
import GameSectionFallback from '../Components/FallbackGameSection.js';
import SoftwareSectionFallback from '../Components/FallbackSoftwareSection.js';
import ShowcaseProject from '../Components/ProjectShowcase.js';
import MiscSectionFallback from '../Components/FallbackMiscSection.js';


function Home() {
    // eslint-disable-next-line
    const noticeHome = useNotification();
    // eslint-disable-next-line
    const BackendURl = process.env.REACT_APP_API || "http://localhost:5000";
    // eslint-disable-next-line
    const [Projects, SetProjects] = useState([]);
    // eslint-disable-next-line
    const [Games, SetGames] = useState([]);
    // eslint-disable-next-line
    const [Software, SetSoftware] = useState([]);
    // eslint-disable-next-line
    const [MiscProjects, SetMiscProjects] = useState([]);
    let ProjectIndex = 0;

    useEffect(() => {
        fetch(`${BackendURl}/api/projects`)
            .then(res => {
                return res.json()
            })
            .then(data => {
                SetProjects(data);
                SetGames(data.filter((element) => {
                    return element.category === "Game";
                }));
                SetSoftware(data.filter((element) => {
                    return element.category === "Software";
                }));
                SetMiscProjects(data.filter((element) => {
                    return element.category !== "Game" && element.category !== "Software";
                }));
            })
            .catch(err => noticeHome("Failed to fetch from " + BackendURl, "Showing Fallback Content | "+ err +" | Please try again later", "Error"));
    }, [BackendURl, noticeHome]);

    return (
        <>
            <NavHeader/>
            <Intro>
                <h1>Hi! My name is Brian!</h1>
                <p>
                    I am a Computer Science Student at <abbr title="California State University, Fullerton">CSUF.</abbr>
                </p>
                <p>
                    Throughout the years, I have learned many coding languages like&nbsp;
                    <code>C, C++, C#, Java, Python, Javascript,</code> and even <code>Assembly-x86</code>
                </p>
                <p>
                    With the knowlege I've aquired. I have developed multiple projects like&nbsp;
                    <a href="https://brianthedevguy.itch.io/astralflight">Rocket Joyride</a>,&nbsp;
                    <a href="https://brianthedevguy.itch.io/oisins-lovely-day">Oisin's Lovely Day</a>,&nbsp;
                    <a href="https://brianthedevguy.itch.io/witch-day-was-it">Witch Day, was it?</a>,&nbsp;
                    And many more to come!
                </p>
                <p>
                    That and many other projects will be showcased throughout this site!
                    I hope you enjoy!
                </p>
            </Intro>
            <div className='HomeContent'>
                <h1>About Me</h1>
            <p>
                I am a Computer Science Student from <abbr title="California State University, Fullerton">CSUF</abbr>.
                I have many interests like computer programming, art, and playing video games.
            </p>
            <p>
                I have been coding for as long as I remember. I started coding in a robotics class in 7th grade. We used code.org to
                learn how to code. I especially loved the creative open ended puzzles where you can pretty much do whatever you want.
            </p>
            <p>
                My goal is to enter the software engineering field, preferrably with game development.
                Game development is my passion. I have messed around with the Unity game engine many times,
                trying all its features. For example, my most recent game is <a href="https://brianthedevguy.itch.io/rocket-joyride-1-week">RocketJoyride</a>,
                A pixel art 2D arcade game where your goal is to reach as far as possible while avoiding obstacles.
            </p>
                <div className='GameDevSection'>
                    <div>
                        <h1>- Games -</h1>
                        <p>
                            I love to make games as a hobby!
                            I mainly use Unity for Game development,
                            which is also where I initally learned C#.
                        </p>
                        <p>
                            Throughout the years, I've improved in game development.
                            This will be shows with the differences between my first Game Jam
                            and my most recent one.
                        </p>
                        <p>
                            You can see the projects by expanding the Expandable Dropdown
                        </p>
                    </div>
                    <ExpandableContent title="Game Development Projects">
                        { (Games.length > 0) ? /* If no projects are fetched from the backend, show fallback content */
                            (
                                Games.map((game) => (
                                <div key={ProjectIndex + 100}>
                                    <ShowcaseEmbed 
                                        Title={game.title} 
                                        Date={game.date}
                                        ButtonURL={game.projectURL}
                                        ButtonText={game.buttonText}
                                        EmbedSrc={game.embedSrc}
                                        EmbedLink={game.embedLink}
                                        EmbedAuthorText={game.embedAuthorText}
                                        EmbedOnLeft={ProjectIndex++ % 2 === 1}
                                    >
                                        {game.disc.split("\n").map((line, idx) => (
                                            <p key={idx}>{line}</p>
                                        ))}
                                        <code>
                                            This Project Uses {game.skills}
                                        </code>
                                    </ShowcaseEmbed>
                                    <hr/>
                                </div>
                            ))) :
                            (<GameSectionFallback/>) /* Fallback Content */
                        }
                    </ExpandableContent>
                </div>
                <div className='SoftwareSection'>
                    <div>
                        <h1>- Software -</h1>
                        <p>
                            I have also done various projects in Software Development.
                            I enjoy making many little coding projects that fill a small
                            niche use. Like the Discord Bot that I used to create AI characters
                            for me and my friends to mess around with.
                        </p>
                        <p>
                            While most of my projects are small one off projects,
                            here are some of the bigger projects I have created.
                        </p>
                        <p>
                            You can see the projects by expanding the Expandable Dropdown
                        </p>
                    </div>
                    <ExpandableContent title="Software Development Projects">
                        { (Software.length > 0) ?
                        (
                            Software.map((project) => (
                                <div key={ProjectIndex + 200}>
                                    <ShowcaseProject 
                                        Title={project.title}
                                        Date={project.date}
                                        EmbedCode={project.embedCode}
                                        EmbedSrc={project.embedSrc}
                                        EmbedLink={project.embedLink}
                                        EmbedAuthorText={project.embedAuthorText}
                                        ImageURLs={project.imgURLs}
                                        ImageAlts={project.imgAlts}
                                        ProjectURL={project.projectURL}
                                        ButtonText={project.buttonText}
                                        OnLeft={ProjectIndex++ % 2 === 1}
                                    >
                                        {project.disc.split("\n").map((line, idx) => (
                                            <p key={idx}>{line}</p>
                                        ))}
                                        <code>
                                            This Project Uses {project.skills}
                                        </code>
                                    </ShowcaseProject>
                                    <hr/>
                                </div>
                        ))) :
                        (<SoftwareSectionFallback/>)
                        }
                    </ExpandableContent>
                </div>
                <div className='WebSection'>
                    <h1>Mini Projects</h1>
                    <p>This is a showcase of my Miniprojects I adapted for my website!</p>
                    <p>
                        Right now the only one I have is a place to create a birthday card, but I plan to
                        expand this section with many more projects in the future.
                    </p>
                    <ExpandableContent title='Website Features'>
                        { (MiscProjects.length > 0) ?
                        (
                            MiscProjects.map((project) => (
                                <div key={ProjectIndex + 300}>
                                    <ShowcaseProject 
                                        Title={project.title}
                                        Date={project.date}
                                        EmbedCode={project.embedCode}
                                        EmbedSrc={project.embedSrc}
                                        EmbedLink={project.embedLink}
                                        EmbedAuthorText={project.embedAuthorText}
                                        ImageURLs={project.imgURLs}
                                        ImageAlts={project.imgAlts}
                                        ProjectURL={project.projectURL}
                                        ButtonText={project.buttonText}
                                        OnLeft={ProjectIndex++ % 2 === 1}
                                    >
                                        {project.disc.split("\n").map((line, idx) => (
                                            <p key={idx}>{line}</p>
                                        ))}
                                        <code>
                                            This Project Uses {project.skills}
                                        </code>
                                    </ShowcaseProject>
                                    <hr/>
                                </div>
                        ))) :
                        (<MiscSectionFallback/>)
                        }
                    </ExpandableContent>
                </div>
            </div>
            <Footer/>
        </>
    );
}

export default Home
